import type { ReactElement, ReactNode } from "react";

// Panel-level failure banner. Use when a SECTION failed to load or an action
// failed in a way the user must notice; inline field errors stay on the
// `.form-error` paragraph class. The API client's error messages already carry
// retry guidance (statusFallback in api/client.ts) — render them verbatim.
export function ErrorNotice({ children }: { children: ReactNode }): ReactElement {
  return (
    <div className="error-notice" role="alert">
      <i className="fas fa-triangle-exclamation" aria-hidden="true" />
      <span>{children}</span>
    </div>
  );
}
